import { css } from '@emotion/react';

import { colors } from '@/styles/color';
import { fontFamily } from '@/styles/font';
import { typographyGlobal } from '@/styles/typography';

/**
 * Global 적용 스타일
 */
const global = css`
	${typographyGlobal}

	:root {
		--font-sans: ${fontFamily.sans};
		--kocsa-primary: ${colors.primary400};
		--kocsa-primary-hover: #0e4280;
		--kocsa-navy: ${colors.brandNavy};
		--kocsa-gray-bg: ${colors.gray};
		--kocsa-border: ${colors.gray100};
		--kocsa-text: ${colors.grayDarker};
		--kocsa-text-muted: ${colors.grayLight};
	}

	html {
		scroll-behavior: smooth;
		font-size: 10px;
		-webkit-text-size-adjust: none;
		-moz-text-size-adjust: none;
		-ms-text-size-adjust: none;
		-o-text-size-adjust: none;
	}

	body {
		font-family: var(--font-sans);
		font-size: 1.6rem;
		font-weight: 400;
		line-height: 1.6;
		color: var(--kocsa-text);
		background-color: #fff;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-rendering: optimizeLegibility;
	}

	::selection {
		background-color: rgba(18, 83, 158, 0.2);
		color: var(--kocsa-navy);
	}

	a:focus-visible,
	button:focus-visible {
		outline: 2px solid var(--kocsa-primary);
		outline-offset: 2px;
	}
	.wrapper {
		display: flex;
		min-height: 100vh;
		flex-direction: column;
	}
	.hidden {
		height: 100%;
		min-height: 100%;
		overflow: hidden;
		touch-action: none;
	}
	main {
		display: flex;
		flex-direction: column;
		flex: 1;
	}
	footer {
		height: 100%;
		@media screen and (max-width: 768px) {
			height: 100%;
		}
	}
`;

export default global;
